import { render } from "./UltraDivider.vue?vue&type=template&id=3c07f9c8&scoped=true"
import script from "./UltraDivider.vue?vue&type=script&lang=js"
export * from "./UltraDivider.vue?vue&type=script&lang=js"

import "./UltraDivider.vue?vue&type=style&index=0&id=3c07f9c8&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c07f9c8"]])

export default __exports__